import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, AutoComplete, Button, Card, Typography } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import postCompany from "../../Redux/APIs/CompanyAPIs/post";
import updateStatus from "../../Redux/APIs/ReqCompanyAPIs/put";
import postCodeFetch from "../../Redux/APIs/postCodeFetch";
import { AddressLookupDetailsAPI } from "../../Redux/APIs/AddressDetailsAPI";

const { Text } = Typography;

const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

const getAddressValues = (value1, value2) => {
  const trimmedValue1 = value1?.trim();
  const trimmedValue2 = value2?.trim();
  if (trimmedValue1?.length > 0 && trimmedValue2?.length > 0)
    return `${trimmedValue1}, ${trimmedValue2}`;
  return trimmedValue1 || trimmedValue2 || "";
};

const AddServicePopUp = ({ services, company, setShowPopup }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [serviceID, setServiceID] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [serviceIcon, setServiceIcon] = useState("");
  const [AddSuggData, setAddSuggData] = useState([]);

  const debouncedGetAddress = debounce((query) => {
    setAddSuggData([]);
    dispatch(postCodeFetch(query, setAddSuggData));
  }, 500);

  const onAddressSearch = (text) => {
    if (text) debouncedGetAddress(text);
  };

  const onAddressSelect = async (value, option) => {
    const address = await AddressLookupDetailsAPI(option.addressId);
    const town = getAddressValues(address?.locality, address?.town_or_city);
    form.setFieldsValue({
      companyName: address?.line_1 || "",
      address1: address?.line_2 || "",
      address2: address?.line_3 || "",
      town: town || "",
      county: address?.county || "",
      postCode: address?.postcode || "",
      latitude: `${address?.latitude}` || "",
      longitude: `${address?.longitude}` || "",
    });
  };

  useEffect(() => {
    setServiceID(company?.company?.service?.[0]);
    const town = getAddressValues(
      company?.company?.address?.locality,
      company?.company?.address?.town
    );
    form.setFieldsValue({
      companyName: company?.company?.address?.address1 || "",
      address1: company?.company?.address?.address2 || "",
      address2: company?.company?.address?.addressline3 || "",
      town: town || "",
      county: company?.company?.address?.county || "",
      postCode: company?.company?.address?.postCode || "",
      latitude: company?.company?.address?.latitude || "",
      longitude: company?.company?.address?.longitude || "",
    });
    getServiceDetails();
  }, [company]);

  useEffect(() => {
    if (serviceID) getServiceDetails();
  }, [serviceID]);

  const getServiceDetails = () => {
    const service = services.filter((s) => serviceID === s?._id);
    setServiceName(service?.[0]?.name);
    setServiceIcon(service?.[0]?.image);
  };

  const handleSubmit = () => {
    const values = form.getFieldsValue();
    dispatch(
      postCompany(
        {
          service: serviceID,
          name: values.companyName,
          address1: values.address1,
          address2: values.address2,
          town: values.town,
          county: values.county,
          postCode: values.postCode,
          required: [],
          image: serviceIcon,
          longitude: values.longitude,
          latitude: values.latitude,
        },
        () => {
          if (company._id) {
            dispatch(updateStatus(company._id));
          }
          setShowPopup(false);

          localStorage.removeItem("popUp");
          localStorage.setItem("popUp", true);
          localStorage.setItem("currentServiceID", serviceID);
          localStorage.setItem("currentServiceName", serviceName);
          localStorage.setItem("currentServiceIcon", serviceIcon);

          navigate(`/service/${serviceName}`);
        }
      )
    );
  };

  const addressOptions = AddSuggData?.map((a) => ({
    value: a?.address,
    label: a?.address,
    addressId: a?.id,
  })) || [];

  const serviceOptions = services
    ?.filter((s) => !s?.hide)
    .map((s) => ({ value: s?._id, label: s?.name })) || [];

  return (
    <Modal
      title="Add Company to Service"
      open={true}
      onCancel={() => setShowPopup(false)}
      footer={null}
      width={600}
      destroyOnClose
    >
      {serviceIcon && (
        <Card size="small" style={{ textAlign: "center", marginBottom: 16 }} bodyStyle={{ padding: 8 }}>
          <img src={serviceIcon} alt={serviceName} style={{ width: 40, height: 40, objectFit: "contain" }} />
          <Text strong style={{ display: "block" }}>{serviceName}</Text>
        </Card>
      )}

      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item label="Service">
          <Select
            value={serviceID}
            onChange={setServiceID}
            options={serviceOptions}
          />
        </Form.Item>

        <Form.Item name="companyName" label="Company Name">
          <AutoComplete
            options={addressOptions}
            onSearch={onAddressSearch}
            onSelect={onAddressSelect}
            placeholder="Company Name / Address lookup"
          />
        </Form.Item>

        <Form.Item name="address1" label="Address Line 1">
          <Input placeholder="Address Line 1" />
        </Form.Item>
        <Form.Item name="address2" label="Address Line 2">
          <Input placeholder="Address Line 2" />
        </Form.Item>
        <Form.Item name="town" label="Town / City">
          <Input placeholder="Town / City" />
        </Form.Item>
        <Form.Item name="county" label="County">
          <Input placeholder="County" />
        </Form.Item>
        <Form.Item name="postCode" label="Postcode">
          <Input placeholder="Postcode" />
        </Form.Item>
        <Form.Item name="longitude" label="Longitude">
          <Input placeholder="Longitude" />
        </Form.Item>
        <Form.Item name="latitude" label="Latitude">
          <Input placeholder="Latitude" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block>Submit</Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddServicePopUp;
